import React, { useEffect, useState } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { TimeSignal, TimeSignalAttribute } from 'graphql/types';
import { useFeatureFlag } from 'modules/common/hooks';
import { MAX_ALLOWED_SPLIT } from '../../constants';
import { OFFSET_ENTRY } from '../../types';
import { useSplitEntriesContext } from '../../SplitEntriesProvider';
import { SplitEntryAccordion } from './SplitEntryAccordion';

type StyleProps = {
  isTiwScreenReaderEnabled: boolean;
};

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: ({ isTiwScreenReaderEnabled }: StyleProps) =>
      isTiwScreenReaderEnabled
        ? theme.palette.information.pageBackground
        : theme.palette.grey[200],
    padding: theme.spacing(2)
  }
}));

type SplitEntryDetailsProps = {
  note: TimeSignal;
  attributes?: TimeSignalAttribute[];
};

export const SplitEntryDetails: React.FC<SplitEntryDetailsProps> = ({
  note,
  attributes
}: SplitEntryDetailsProps) => {
  const isTiwScreenReaderEnabled = useFeatureFlag('isTiwScreenReaderEnabled');
  const classes = useStyles({ isTiwScreenReaderEnabled });
  const [expanded, setExpanded] = useState('');
  const { splitEntries } = useSplitEntriesContext();

  useEffect(() => {
    const newlyAddedOffsetEntry = splitEntries.find(
      (entry) => entry.newlyAddedOffsetEntry
    );
    if (newlyAddedOffsetEntry) {
      setExpanded(newlyAddedOffsetEntry.id);
      delete newlyAddedOffsetEntry.newlyAddedOffsetEntry;
    }
  }, [splitEntries]);

  if (splitEntries.length === 1) {
    return <></>;
  }

  return (
    <div className={classes.root} data-testid="split-entries-details">
      {splitEntries.map((entry, index) =>
        entry.id === OFFSET_ENTRY ? (
          <React.Fragment key={entry.id}></React.Fragment>
        ) : (
          <SplitEntryAccordion
            note={note}
            attributes={attributes}
            expanded={expanded === entry.id}
            key={entry.id}
            entry={entry}
            enableSplit={splitEntries.length < MAX_ALLOWED_SPLIT}
            setExpanded={setExpanded}
            position={index}
          />
        )
      )}
    </div>
  );
};
